<template>
  <tr v-if="!ligne.deleted">
    <td v-if="ligne.ephemere">
      <select
        v-model="ligne.codeUnite"
      >
        <option
          v-for="unite of unitesAjoutables"
          :key="unite"
          :value="unite"
        >
          {{ unite }}
        </option>
      </select>
    </td>
    <td v-else>
      {{ ligne.codeUnite }}
    </td>
    <td>
      <input
        type="checkbox"
        v-model="ligne.longueurVariable"
      >
    </td>
    <td>
      <input
        type="checkbox"
        v-model="ligne.largeurVariable"
      >
    </td>
    <td>
      <input
        type="checkbox"
        v-model="ligne.hauteurVariable"
      >
    </td>
    <td>
      <input
        type="checkbox"
        v-model="ligne.diametreVariable"
      >
    </td>
    <td>
      <input
        type="checkbox"
        v-model="ligne.densiteVariable"
      >
    </td>
    <td>
      <input
        type="checkbox"
        v-model="ligne.contenanceVariable"
      >
    </td>
    <td>
      <input
        type="checkbox"
        v-model="ligne.poidsVariable"
      >
    </td>
    <td>
      <span
        title="Supprimer"
        class="ui-icon ui-icon-trash"
        @click="deleteDimensionVariable(index)"
      />
    </td>
  </tr>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    ligne: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters([
      'unitesAjoutables'
    ])
  },
  methods: {
    ...mapActions([
      'deleteDimensionVariable'
    ])
  }
}
</script>
